import { queryOptions } from '@tanstack/react-query'

import { getApi, unwrap } from '@/api/client'
import { qk } from '@/api/query-keys'
import type { Settings } from '@/api/types'

/**
 * Instance settings, including the backend-owned limits the UI mirrors.
 *
 * Unauthenticated and effectively static for the life of the page, so it is
 * fetched once at boot and never refetched on its own. An admin changing a
 * setting invalidates this key explicitly.
 */
export function settingsQuery() {
  return queryOptions({
    queryKey: qk.settings(),
    staleTime: Infinity,
    gcTime: Infinity,
    queryFn: (): Promise<Settings> => unwrap(getApi().GET('/api/settings/')),
  })
}
